<template>
  <div class="pop-container" v-if="userInfo">
    <div class="user-top">
      <div class="user-img" :style="{ backgroundImage: 'url(' + userPic + ')' }"
        v-if="userInfo && userPic">
        <img :src="userPic" alt="" @error="onErrorAvatar">
        <input type="file" class="input-file" ref="inputer" title="点击更新头像" @change="update"
          accept="image/gif, image/jpeg, image/jpg, image/png, image/svg">
        <div class="user-edit">
          <span class="iconfont icon-edit-fill"></span>
        </div>
      </div>

      <div class="user-img" v-else>
        <img :src="touxiang" alt="">
        <input type="file" class="input-file" ref="inputer" @change="update"
          accept="image/gif, image/jpeg, image/jpg, image/png, image/svg">
        <div class="user-edit">
          <span class="iconfont icon-edit-fill"></span>
        </div>
      </div>
      <div class="user-info">
        <p v-if="userInfo && userInfo.phone">
          <span>手机号</span>
          <em>{{ showPhone }}</em>
        </p>
        <p>
          <el-tooltip effect="light" placement="bottom">
            <div slot="content">{{ userInfo.ip }}</div>
            <div class="flex">
              <span>当前IP</span>
              <em>{{ userInfo.ip }}</em>
            </div>
          </el-tooltip>
        </p>
      </div>
    </div>
    <div class="user-right">
      <!-- <h3 class="title">当前授权资源数量：{{userInfo.show_ids}}</h3> -->
      <div class="user-source flex">
        <div class="source-item" v-for="(item, index) in menu" :key="index" @click="goDetail(item)">
          <div class="item-pic flex jc"><span :class="item.icon"></span> </div>
          <p>
            <em>{{ item.name }}</em><i>{{ item.count }}</i>
          </p>
        </div>
      </div>
    </div>
    <div class="user-manager">
      <p class="manager-item" @click.stop="changePwd" v-if="false">
        <span class="iconfont icon-edit-box-line"></span>
        <em>修改密码</em>
      </p>
      <p class="manager-item logoff" @click.stop="logOff" title="注销">
        <!-- <span class="iconfont icon-logout-box-line"></span> -->
        <em>注销账号</em>
      </p>
      <p class="manager-item exit" @click.stop="exit" title="退出登录">
        <span class="iconfont icon-logout-box-line"></span>
        <em>退出登录</em>
      </p>
    </div>

    <pop-info v-if="popShow">
      <p>{{ popTxt }}</p>
    </pop-info>
  </div>
</template>

<script>
import touxiang from '../../assets/images/defaultImg.jpg';
import popInfo from './popInfo.vue';
import { mapMutations, mapState } from 'vuex'
import { encrypt, decrypt } from '../../utils/sm4Util';
import AppDialog from '../app-dialog';
export default {
  components: { popInfo, AppDialog },
  name: 'userRights',
  props: {
    msg: String
  },
  data() {
    return {
      touxiang,
      popShow: false,
      popTxt: '',
      num: 2,
      showPhone: '',
      userPic: '',
    }
  },
  async mounted() {
    if (!this.userInfo || !this.userInfo.id) {
      await this.getUserInfo()
    }
    this.initPage()
  },
  computed: {
    ...mapState({ userInfo: 'userInfo', menu: state => state.UserRightMenu }),
  },
  methods: {
    ...mapMutations(['updateUserInfo', "getUserInfo"]),
    initPage() {
      if (!this.userInfo.ip || this.userInfo.id != window.ip) {
        this.userInfo.ip = window.ip
      }
      this.showPhone = this.userInfo.phone ? decrypt(this.userInfo.phone) : ''
      this.updateUserInfo(this.userInfo);//更新全局状态
      this.getHeadImg();
      this.getMenuList()

      this.userPic = this.userInfo.cover_img ? this.userInfo.showpath + this.userInfo.cover_img : ''
    },

    getHeadImg() {
      if (!this.userInfo && !this.userInfo.phone && !this.userInfo.openid) return;
      let params = {
        // username:this.username
        // phone:decrypt(this.userInfo.phone) 
        phone: this.userInfo.phone || encrypt(this.userInfo.openid)
      }
      this.$api.userApi.getHeadImg(params).then(res => {
        if (!this.$utils.getCookie("login")) return
        if (res.data && res.data.cover_img) {
          let newInfo = {
            ...this.userInfo,
            userPic: res.data.cover_img ? res.showpath + res.data.cover_img : ''
          }
          this.userPic = res.data.cover_img ? res.showpath + res.data.cover_img : ''
          this.updateUserInfo(newInfo);
        }
      })
    },

    async getMenuList() {
      let res = await this.$api.userApi.getRightCount({
        user_id: this.userInfo.id
      });
      
      this.menu.map(t => {
        if (t.name == "授权资源") {
          t.count = res.total;
        }
        if (t.name == "我的点赞") {
          t.count = res.data.likeCount;
        }
        if (t.name == "我的收藏") {
          t.count = res.data.collectCount;
        }
        if (t.name == "下载记录") {
          t.count = res.data.downloadCount;
        }
      });
    },

    goDetail(item) {
      this.$router.push({
        path: '/user',
        query: { type: item.id }
      })
    },
    changePwd() {
      this.$emit("changeView", {
        viewName: 'ResetPwd'
      })
    },
    exit() {
      this.$utils.deleteCookie("login");
      let loginObj = {}

      setTimeout(() => {
        this.$emit("hideView");
        this.updateUserInfo(loginObj);
        window.location.reload()
      }, 1000);
    },

    async logOff() {
      await this.$confirm(`注销后，您的用户信息会全部清除！`, "温馨提示", { type: "warning" });
      this.submitDelete()
    },

    submitDelete() {
      let id = this.userInfo.id
      this.$api.userApi.deleteUser(id).then(res => {
        this.$utils.deleteCookie("login");
        let loginObj = {}
        this.$emit("hideView");
        this.updateUserInfo(loginObj);
        this.dialogVisible = false
      })
    },

    update(e) {   // 上传照片
      let that = this
      let file = e.target.files[0]
      if (Math.floor(file.size / 1024) > 5 * 1024) {
        this.popTxt = "请选择5M以内的图片！";
        this.popShow = true;
        setTimeout(() => {
          this.popShow = false;
        }, 2000);
        return false;
      }
      const fileName = file.name
      let fileType = fileName.substring(fileName.lastIndexOf(".") + 1)
      fileType = fileType ? fileType.toLowerCase() : ''
      if (fileType != 'jpg' && fileType != 'jpeg' && fileType != 'gif' && fileType != 'png') {
        this.popTxt = "请上传jpg,png格式的图片！";
        this.popShow = true;
        setTimeout(() => {
          this.popShow = false;
        }, 2000);
        return false;
      }

      /* eslint-disable no-undef */
      let param = new FormData()  // 创建form对象
      param.append('file', file)  // 通过append向form对象添加数据
      param.append('chunk', '0') // 添加form表单中其他数据
      // console.log(param.get('file')) // FormData私有类对象，访问不到，可以通过get判断值是否传进去

      this.popTxt = "头像上传中...";
      this.popShow = true;
      let params = {
        // username:this.username,
        phone: this.userInfo.phone ? decrypt(this.userInfo.phone) : this.userInfo.openid,
        param: param,
      }
      this.$api.userApi.Upload(params).then(res => {
        if (res.data.code == 0) {
          let userPic = res.data.url;
          let newInfo = {
            ...this.userInfo,
            cover_img: userPic,
            userPic: userPic
          }
          this.userPic = res.data.showpath + res.data.url
          this.updateUserInfo(newInfo); //更新全局状态
          this.$utils.setCookie("login", JSON.stringify(newInfo), 30)
        }
        this.popTxt = res.data.msg;
        this.popShow = true
        setTimeout(() => {
          this.popShow = false;
        }, 2000);
      }).catch(fail => {
        this.popTxt = '暂时无法上传，请稍后再试'
        this.popShow = true
        setTimeout(() => {
          this.popShow = false;
        }, 2000);
      })
    },
    onErrorAvatar() {
      this.userPic = this.touxiang
    },
  },
}
</script>
<style lang="scss" scoped>
.pop-container {
  padding-bottom: 50px;
}

.user-source {
  justify-content: space-between;
  padding-top: 20px;

  .source-item {
    flex: 1;
    cursor: pointer;

    .item-pic {
      width: 48px;
      height: 48px;
      background: #FFE8E8;
      color: #B41717;
      border-radius: 48px;
      margin: 0 auto 9px;

      span {
        font-size: 20px;
      }
    }

    p {
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
}</style>